import { render, staticRenderFns } from "./FeedbackActions.vue?vue&type=template&id=c66b8da6&scoped=true"
import script from "./FeedbackActions.vue?vue&type=script&lang=js"
export * from "./FeedbackActions.vue?vue&type=script&lang=js"
import style0 from "./FeedbackActions.vue?vue&type=style&index=0&id=c66b8da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66b8da6",
  null
  
)

export default component.exports